import { Close, Search } from '@rsuite/icons'
import { isEmpty } from 'lodash'
import { useState } from 'react'
import { Input, InputGroup, Pagination, Table } from 'rsuite'
import RSuiteTable from 'src/cms/helpers/components/rsuiteTable'
import AddProductSchema from './AddProductSchema'
import { useGetProductSchema } from './hooks/useGetProductSchema'
import DesignComponent from '../../common/components/designComponent'

const Cell = Table.Cell

const ProductSchema = () => {
  const [open, setOpen] = useState(false)
  const [selectedId, setSelectedId] = useState('')
  const [params, setParams] = useState({
    search: '',
    page: 1,
    limit: 10,
  })

  const { data: productSchemaData, isLoading: loading } = useGetProductSchema(params)

  const handleChangeLimit = (dataKey: any) => {
    setParams({
      ...params,
      limit: dataKey,
    })
  }

  const ActionCell = ({ rowData, dataKey, ...props }: any) => {
    return (
      <Cell {...props} className='link-group'>
        <button
          className={'btn btn-primary btn-sm me-2'}
          onClick={() => {
            setOpen(true)
            setSelectedId(rowData?.id)
          }}
        >
          Edit
        </button>
      </Cell>
    )
  }

  const columns = [
    {
      label: 'S.N.',
      dataKey: 'sn',
      width: 50,
      cell: <Cell dataKey='sn' />,
    },
    {
      label: 'Product Name',
      dataKey: 'title',
      cell: <Cell dataKey='title' />,
      sortable: false,
      flexGrow: 1,
    },
    {
      label: 'CBS Code',
      dataKey: 'cbs_code',
      flexGrow: 1,
      cell: <Cell dataKey='cbs_code' />,
    },
    {
      label: 'Action',
      width: 200,
      align: 'center',
      cell: <ActionCell dataKey='id' />,
      fixed: 'right',
    },
  ]

  return (

    <div className='shadow p-3 bg-white rounded' data-cy='shadow-user'>
      <DesignComponent
        moduleName='Product Scheme'
        params={params}
        setParams={setParams}
        exportShow={false}
        importShow={false}
        addShow={false}
        deleteShow={false}
        toggleMultipleShow={false}
        showReload={false}
      />



      <div className='datatable'>
        <RSuiteTable
          columns={columns}
          showLoading={loading}
          data={productSchemaData?.data?.productScheme?.map((item: any, index: any) => ({
            ...item,
            sn: index + 1,
          }))}
        />
        <Pagination
          prev
          next
          first
          last
          ellipsis
          boundaryLinks
          maxButtons={5}
          size='sm'
          layout={['total', '-', 'limit', '|', 'pager', 'skip']}
          total={productSchemaData?.data?.meta?.total ?? 0}
          limitOptions={[10, 20, 50, 100]}
          limit={params?.limit}
          activePage={params?.page}
          onChangePage={(value) => setParams({ ...params, page: value })}
          onChangeLimit={handleChangeLimit}
        />
      </div>

      <AddProductSchema open={open} handleClose={() => setOpen(false)} id={selectedId} />
    </div>

  )
}

export default ProductSchema
